/**
 * Funções de renderização HTML para o módulo Oferta Formulário
 */

import { escapeHtml, getOfferTitle, getOfferDescription, getOfferImageUrl } from '../helpers/ofertaFormularioHelpers.js';
import { renderCheckboxes } from './sharedCheckboxes.js';

/**
 * Renderiza campos opcionais baseado nos dados da oferta
 */
export function renderOptionalFields(cssPrefix, ofertaData) {
    let html = '';

    // Campo CPF
    if (ofertaData?.hasCpf) {
        html += `
            <input type="text" name="cpf" id="${cssPrefix}-cpf" placeholder="CPF*" required pattern="\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}" maxlength="14" />
            <div id="${cssPrefix}-cpf-error" class="${cssPrefix}-error"></div>
        `;
    }

    // Campo CEP
    if (ofertaData?.zipCode) {
        html += `
            <input type="text" name="zipCode" id="${cssPrefix}-cep" placeholder="CEP*" pattern="\\d{5}-\\d{3}" />
            <div id="${cssPrefix}-cep-error" class="${cssPrefix}-error"></div>
        `;
    }

    // Campo Data de Nascimento
    if (ofertaData?.birthDate) {
        html += `
            <div class="${cssPrefix}-birthdate-wrapper">
                <input type="date" name="birthDate" id="${cssPrefix}-birthdate" required />
                <label for="${cssPrefix}-birthdate" class="${cssPrefix}-birthdate-placeholder">Data de nascimento *</label>
            </div>
            <div id="${cssPrefix}-birthdate-error" class="${cssPrefix}-error"></div>
        `;
    }

    return html;
}

/**
 * Constrói HTML completo do formulário
 */
export function buildFormHTML(config, ofertaData) {
    const { cssPrefix } = config;

    // Determina textos dos checkboxes
    const hasOptInWidget = ofertaData?.optin_widget || false;
    const textAceite = ofertaData?.aceptText || '';
    const textCiente = ofertaData?.textAware || '';
    const textDeclaro = ofertaData?.textDeclare || '';

    // Obtem dados formatados
    const imageUrl = getOfferImageUrl(ofertaData);
    const offerTitle = getOfferTitle(ofertaData);
    const offerDescription = getOfferDescription(ofertaData);

    return `
        <div class="${cssPrefix}-wrapper">
            ${config.textHeader ? `<div class="${cssPrefix}-header">${escapeHtml(config.textHeader)}</div>` : ''}
            
            <div class="${cssPrefix}-col1">
                <div class="${cssPrefix}-titulos" id="${cssPrefix}-titulos">
                    <h2>${escapeHtml(config.title0km)}</h2>
                    ${offerTitle ? `<h3 style="color:${config.color}">${escapeHtml(offerTitle)}</h3>` : ''}
                    ${offerDescription ? `<p>${escapeHtml(offerDescription)}</p>` : ''}
                </div>
                ${imageUrl ? `
                    <figure class="${cssPrefix}-image ${!config.isImageMobile ? 'hide-mobile' : ''}" id="${cssPrefix}-image">
                        <img src="${imageUrl}" alt="Oferta" loading="lazy" decoding="async" />
                    </figure>
                ` : ''}
            </div>

            <div class="${cssPrefix}-col2">
                <form class="${cssPrefix}-form" id="${cssPrefix}-form" novalidate>
                    <h4>${escapeHtml(config.titleForm)}</h4>
                    
                    <input type="text" name="name" id="${cssPrefix}-name" placeholder="Nome completo*" required />
                    <div id="${cssPrefix}-name-error" class="${cssPrefix}-error"></div>

                    <input type="email" name="email" id="${cssPrefix}-email" placeholder="E-mail*" required />
                    <div id="${cssPrefix}-email-error" class="${cssPrefix}-error"></div>

                    <input type="tel" name="phone" id="${cssPrefix}-phone" placeholder="Telefone*" required pattern="\\(\\d{2}\\) \\d{5}-\\d{4}" maxlength="15" />
                    <div id="${cssPrefix}-phone-error" class="${cssPrefix}-error"></div>
                    
                    ${renderOptionalFields(cssPrefix, ofertaData)}
                    
                    <div class="${cssPrefix}-checkbox-group" id="${cssPrefix}-checkboxes">
                        ${renderCheckboxes(cssPrefix, hasOptInWidget, textAceite, textCiente, textDeclaro, ofertaData?.optin_widget, { requiredMark: false })}
                    </div>
                    
                    <button type="submit" aria-label="Finalizar cadastro">Finalizar cadastro</button>
                </form>
                
                <div class="${cssPrefix}-message" id="${cssPrefix}-message"></div>
            </div>
        </div>
    `;
}
